module.exports = __webpack_public_path__ + "img/gw.942d4006.svg";